export default "__VITE_ASSET__Ax$GpUmf__"